module.exports = __webpack_public_path__ + "media/images/story/top/step2-17866734b5b6308213b24abbf7cdeaf3.svg";